/**
 * 通知一覧（未読一覧など）の取得結果を、表示中の一覧へ足すときの共通処理。
 *
 * 一覧は API の offset ページング（limit / page）で取得している。
 * 表示中に別の端末（アプリなど）で既読にされると、サーバー側の件数が減って
 * 次のページの先頭が前にずれ、表示済みの項目がもう一度返ってくる。
 * そのため、追記するときは id で重複を取り除く（NWS_SMILELINE-1637）。
 */

interface HasId {
  id: number | string
}

/**
 * current の後ろに incoming を足す。current にすでにある id と、
 * incoming の中で重複している id は足さない。current の並びは変えない。
 */
export function appendUniqueById<T extends HasId>(current: T[], incoming: T[]): T[] {
  const seen = new Set<number | string>(current.map(item => item.id))
  const added: T[] = []
  for (const item of incoming) {
    if (seen.has(item.id)) continue
    seen.add(item.id)
    added.push(item)
  }
  return [...current, ...added]
}

interface Selectable extends HasId {
  selected: boolean
}

/**
 * 一覧を取り直して置き換えるとき、置き換え前にチェックを付けていた項目の
 * チェックを、新しい一覧の同じ id の項目へ引き継ぐ（自動更新でチェックが外れないように）。
 */
export function carryOverSelection<T extends Selectable>(previous: T[], next: T[]): T[] {
  const selectedIds = new Set<number | string>(
    previous.filter(item => item.selected).map(item => item.id)
  )
  if (selectedIds.size) {
    next.forEach(item => {
      if (selectedIds.has(item.id)) item.selected = true
    })
  }
  return next
}
